module.exports = __webpack_public_path__ + "img/unavailable_printing.b34e0bf8.svg";